export default __webpack_public_path__ + "static/media/jamaica_flag.0d243dcb.png";